import { Component, Host, h, Prop, State, Event, Element, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-dropdown',
  styleUrl: 'cobalt-dropdown.css'
})
export class CobaltDropdown {
  /**
   * Align the dropdown with the trigger element.
   */
  @Prop({ mutable: true }) alignment?: 'left' | 'center' | 'right' = 'center'
  /**
   * Change the width of the dropdown.
   */
  @Prop({ mutable: true }) width?: 'small' | 'medium' | 'large' = 'small'
  /**
   * aggragation of all the item selected.
   */
  @State() allSelectedItems: any[] = []
  /**
   * Boolean indicating if the dropdown is open.
   */
  @State() open: boolean = false
  /**
   * currentIndex for keyboard navigation
   */
  @State() currentIndex: number
  @State() trigger: HTMLElement
  @State() popover: HTMLElement
  /**
   * Emitted when the selected values of the dropdown have changed.
   */
  @Event() cobaltDropdownItemsChange: EventEmitter

  @Element() element: HTMLElement

  render(): any {
    return (
      <Host>
        <core-dropdown
          alignment={this.alignment}
          width={this.width}
          onCoreDropdownItemsChange={e => {
            this.cobaltDropdownItemsChange.emit(e.detail)
          }}
        >
          <slot slot="trigger-element" name="trigger-element"></slot>
          <slot></slot>
        </core-dropdown>
      </Host>
    )
  }
}
